export default __webpack_public_path__ + "static/media/15.e5015f50.jpg";